<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2>Fórmulas
        <configTools 
          [Title]="tituloTabla"
          (AddChange)="add($event)"
          [eliminando]="eliminandoFormula"
          [bImportExport]="importExport"
          [Permiso]="permisoEdicion"
          ></configTools>
        </h2>
    </div>
</div>
<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="header">
        <div class="ibox-content">
          <div>
            <div class="form-group row">
              <mat-error *ngIf="eliminacionInvalida" class="eliminacionInvalida">{{MensajeError}}</mat-error>
            </div>
            <div class="table table-striped">
              <p-table #dt [value]="formulasList" [rows]="10" [paginator]="true" [globalFilterFields]="['codigo', 'descripcion']"
                       [rowHover]="true" dataKey="id"
                       currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Fórmulas" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                  <div class="p-d-flex p-ai-center p-jc-between">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search"></i>
                      <input pInputText type="text" class="p-inputtext p-component" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
                    </span>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="codigo">Código <p-sortIcon field="codigo"></p-sortIcon></th>
                    <th pSortableColumn="descripcion">Descripción <p-sortIcon field="descripcion"></p-sortIcon></th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-formula let-rowIndex="rowIndex">
                  <tr>
                    <td>{{formula.codigo}}</td>
                    <td>{{formula.descripcion}}</td>
                    <td>
                      <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="visualizarDetalle(formula, rowIndex)"></button>
                      <button pButton pRipple pTooltip="Eliminar" tooltipPosition="bottom" icon="pi pi-trash" class="btn btn-xs  btn-danger" (click)="delete(formula)"></button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
